import { BreakpointObserver } from '@angular/cdk/layout';
import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { distinctUntilChanged } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  public breakpointObserver = inject(BreakpointObserver)

  public currentBreakpoint = '';

  
  private sizes = ['(min-width: 960px)']
  readonly isOpen : WritableSignal<boolean> = signal(false)
  readonly breakpoint$ = this.breakpointObserver.observe(this.sizes).pipe(distinctUntilChanged());
 
 
  constructor() {
    this.breakpoint$.subscribe(() =>
      this.breakpointChanged()
    );
  }

  public toggle() {
    this.isOpen.update(value => !value)
  }

  private breakpointChanged() {
    if (this.breakpointObserver.isMatched('(min-width: 960px)')) {
      this.isOpen.set(false)
    }
    else {
      this.isOpen.set(true)
    }
  }

  

}
